enum ENV_NAME_TYPE {
  DEV = 'dev',
  UAT = 'uat',
  PROD = 'prod',
  SIT = 'sit'
}

// Info: Get the host to indentify whether the host is uat, sit or prod
const host = window?.location?.hostname ?? '';

// Info: extract the host type from url
let envName = ENV_NAME_TYPE.UAT;
if (host?.includes("uat")) {
  envName = ENV_NAME_TYPE.UAT
} else if (host?.includes("dev")) {
  envName = ENV_NAME_TYPE.DEV
} else if (host?.includes("sit")) {
  envName = ENV_NAME_TYPE.SIT
} else {
  envName = ENV_NAME_TYPE.PROD
}

// const publicUrl = process.env.PUBLIC_URL

const sitecorURL = {
  [ENV_NAME_TYPE.PROD]: {
    url: 'https://contentportal.emiratesnbd.com',
    token: 'VKAAUB7QXWG3S67943XD2MWP'
  },
  [ENV_NAME_TYPE.UAT]: {
    url: 'https://uatcontentportal.emiratesnbd.com',
    token: 'X9H6I5B2MZ73HGNZ9NQSF363'
  },
  [ENV_NAME_TYPE.DEV]: {
    url: 'https://uatcontentportal.emiratesnbd.com',
    token: 'X9H6I5B2MZ73HGNZ9NQSF363'
  },
  [ENV_NAME_TYPE.SIT]: {
    url: 'https://uatcontentportal.emiratesnbd.com',
    token: 'X9H6I5B2MZ73HGNZ9NQSF363'
  }
}
const adobeURL = {
  [ENV_NAME_TYPE.PROD]: {
    url: 'https://assets.adobedtm.com/f38911e57abc/9f6583850369/launch-a35afee18b44.min.js'
  },
  [ENV_NAME_TYPE.UAT]: {
    url: 'https://assets.adobedtm.com/f38911e57abc/9f6583850369/launch-b0b1bdded3af-development.min.js'
  },
  [ENV_NAME_TYPE.DEV]: {
    url: 'https://assets.adobedtm.com/f38911e57abc/9f6583850369/launch-b0b1bdded3af-development.min.js'
  },
  [ENV_NAME_TYPE.SIT]: {
    url: 'https://assets.adobedtm.com/f38911e57abc/9f6583850369/launch-b0b1bdded3af-development.min.js'

  }
};

export const env = {
  // reduxLogger: !PROD,
  siteCoreBaseUrl: sitecorURL[envName].url,
  siteCoreBasePath: `/content/chat`,
  nodeServerBasePath: `/eiapi/v1`,
  siteCoreToken: sitecorURL[envName].token,
  adobeBaseUrl: adobeURL[envName].url,
  isIframe:true
}
